<template lang="pug">
  v-menu(v-model="show", absolute, :position-x="x", :position-y="y")
    v-list.py-0(v-if="path", dense)
      v-list-item
        v-list-item-content: v-list-item-subtitle(style="word-break: break-word; white-space: normal") {{path}}
      Divider
      v-list-item(:to="`/${path}`")
        v-list-item-icon.mr-2
        v-list-item-content: v-list-item-title Open
      template(v-if="!isDir")
        Divider(inset=48)
        v-list-item(@click="download.createJob(downloadPaths, name)")
          v-list-item-icon.mr-2: v-icon mdi-download
          v-list-item-content: v-list-item-title Download file
      template(v-if="isDir && downloadPaths.length")
        Divider(inset=48)
        v-list-item(@click="download.createJob(downloadPaths, name)")
          v-list-item-icon.mr-2: v-icon mdi-download
          v-list-item-content: v-list-item-title Download files ({{downloadPaths.length}})
      template(v-if="isDir && downloadPathsR.length && downloadPathsR.length != downloadPaths.length")
        Divider(inset=48)
        v-list-item(@click="download.createJob(downloadPathsR, name)")
          v-list-item-icon.mr-2: v-icon mdi-download-multiple
          v-list-item-content: v-list-item-title Download all ({{downloadPathsR.length}})
      Divider
      .py-2
      Divider
      v-list-item(@click="")
        v-list-item-icon.mr-2: v-icon mdi-magnify
        v-list-item-content: v-list-item-title Search
      Divider(inset=48)
      v-list-item(@click="")
        v-list-item-icon.mr-2: v-icon mdi-close
        v-list-item-content: v-list-item-title Close menu
</template>

<script>
import Divider from '@/components/Divider';
import assetBundle from '@/assetBundle';
import download from '@/download';

export default {
  name: 'Menu',

  components: { Divider },

  data() {
    return {
      assetBundle,
      download,

      show: false,
      path: null,
      x: 0,
      y: 0,
      downloadPaths: 0,
      downloadPathsR: 0,
    };
  },

  computed: {
    file() {
      return assetBundle.get(this.path);
    },
    files() {
      return this.file;
    },
    name() {
      const names = this.path.split('/');
      return names[names.length - 1];
    },
    isDir() {
      return assetBundle.isDir(this.path);
    },
  },

  mounted() {
    this.$root.$on('menu', (path, x, y) => {
      this.show = false;
      this.path = path;
      this.x = x;
      this.y = y;
      this.$nextTick(() => this.show = true);
      this.$nextTick(() => this.downloadPaths = assetBundle.list(this.files));
      this.$nextTick(() => this.downloadPathsR = assetBundle.list(this.files, true));
    });
  }
};
</script>